import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetCredits } from "../../Services/AIListingCreation";
import { logout } from "../../Services/Authentication";

interface HeaderState {
    generatephotos: number;
    enhancephotos: number;
    iamotions: number;
    listings: number;
}

export const fetchHeaderData = createAsyncThunk<HeaderState, void>(
    "header/fetchData",
    async (): Promise<HeaderState> => {
        const data = await GetCredits();
        return {
            generatephotos: data?.generatephotos ?? 0,
            enhancephotos: data?.enhancephotos ?? 0,
            iamotions: data?.iamotions ?? 0,
            listings: data?.listings ?? 0
        };
    }
);

const initialState: HeaderState = {
    generatephotos: 0,
    enhancephotos: 0,
    iamotions: 0,
    listings: 0
};

const headerSlice = createSlice({
    name: "header",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchHeaderData.fulfilled, (state, action) => {
            state.generatephotos = action.payload.generatephotos;
            state.enhancephotos = action.payload.enhancephotos;
            state.iamotions = action.payload.iamotions;
            state.listings = action.payload.listings;
        });
    },
});

export default headerSlice.reducer;
